import { ListFilter } from 'lucide-react';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@nesso/ui/primitives/select';

import type { SessionNoteStatus } from '@/entities/session';
export type PastSessionsStatusFilterValue = SessionNoteStatus | 'ALL';

const OPTIONS = [
    { value: 'ALL', label: 'All sessions' },
    { value: 'DONE', label: 'Done' },
    { value: 'TODO', label: 'To-Do' },
] as const satisfies ReadonlyArray<{ value: PastSessionsStatusFilterValue; label: string }>;

type Props = {
    value: PastSessionsStatusFilterValue;
    onValueChange: (value: PastSessionsStatusFilterValue) => void;
};

export function PastSessionsStatusFilter({ value, onValueChange }: Props) {
    const updateStatus = (x: PastSessionsStatusFilterValue) => onValueChange(x);

    return (
        <Select value={value} onValueChange={updateStatus}>
            <SelectTrigger className="w-auto gap-2 h-9">
                <div className="flex items-center gap-2 text-sm">
                    <ListFilter className="h-4 w-4 text-foreground" />
                    <SelectValue placeholder="All sessions" />
                </div>
            </SelectTrigger>
            <SelectContent>
                {OPTIONS.map((o) => (
                    <SelectItem key={o.value} value={o.value}>
                        {o.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
